module.exports = __webpack_public_path__ + "img/feature-1.40d4437f.jpg";